import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import PageTitle from "components/WMS/Mobile/PageTitle";

SortSingleTrolleyHeader.propTypes = {
    isInSorting: PropTypes.bool,
    trolleyName: PropTypes.string,
    trolleyIndex: PropTypes.number
};

function SortSingleTrolleyHeader({isInSorting = false, trolleyName, trolleyIndex }) {
    const titleId = isInSorting ? "wms.sorting.inSorting.trolley.title" : "wms.sorting.trolleyPeek.title";
    const subtitleId = isInSorting ? "wms.sorting.inSorting.trolley.subtitle" : "wms.sorting.trolleyPeek.subtitle";

    return (
        <PageTitle 
            title={(
                <>
                    <FormattedMessage id={titleId} /> 
                    &nbsp;
                    {trolleyName ?? trolleyIndex}
                </>
            )}
            subtitle={<FormattedMessage id={subtitleId}/>}
        />
    );
}

export default SortSingleTrolleyHeader;
